export default "__VITE_ASSET__BwhkWAF5__"